import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faRocket } from '@fortawesome/free-solid-svg-icons';
import '../ecourt/ecourt.css';
import { PageHeader } from '../ecourt/EcourtUi';

export default function Marketplace() {
  return (
    <div className="ecourt-app">
      <div className="ec-page">
        <PageHeader title="Marketplace" subtitle="Legal services, templates and tools for your practice." />
        <div className="ec-empty">
          <span className="ec-tool-icon tone-yellow mb-2"><FontAwesomeIcon icon={faStore} /></span>
          <div className="fw-semibold ec-strong mb-1" style={{ fontSize: '1.2rem' }}>Marketplace</div>
          <div className="ec-muted mb-3">Legal templates, stamp papers, research tools and more — all in one place.</div>
          <span className="ec-badge ec-badge-yellow" style={{ fontSize: '.95rem', padding: '6px 16px' }}>
            <FontAwesomeIcon icon={faRocket} /> Coming soon
          </span>
        </div>
      </div>
    </div>
  );
}